import type { ReactNode } from 'react'
import { Radio } from './Radio'
import './settingsKit.css'

export interface SettingsRadioOption {
  value: string
  label: ReactNode
  hint?: ReactNode
  disabled?: boolean
}

export interface SettingsRadioListProps {
  name: string
  options: SettingsRadioOption[]
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  className?: string
  testId?: string
}

/**
 * SettingsRadioList (SR2, §3.3, §3.7)
 * Vertical radio list for 2–6 small choices (Microsoft Teams style).
 * Built on Common Radio.
 */
export function SettingsRadioList({
  name,
  options,
  value,
  onChange,
  disabled = false,
  className,
  testId,
}: SettingsRadioListProps) {
  return (
    <div
      className={['skRadioList', className].filter(Boolean).join(' ')}
      role="radiogroup"
      data-testid={testId}
    >
      {options.map((option) => {
        const isChecked = option.value === value
        const isDisabled = disabled || Boolean(option.disabled)

        return (
          <div className="skRadioList__item" key={option.value}>
            <Radio
              name={name}
              value={option.value}
              checked={isChecked}
              disabled={isDisabled}
              onChange={(checked) => {
                if (checked) {
                  onChange?.(option.value)
                }
              }}
              label={
                <span className="skRadioList__text">
                  <span className="skRadioList__label">{option.label}</span>
                  {option.hint ? (
                    <small className="skRadioList__hint">
                      {option.hint}
                    </small>
                  ) : null}
                </span>
              }
            />
          </div>
        )
      })}
    </div>
  )
}
